import buildNavigateToCreatedDashboardSubscription from './navigateToCreatedDashboard';
import buildNavigateToCreatedSkillSubscription from './navigateToCreatedSkill';
import buildNavigateAwayOnSkillDeleteSubscription from './navigateAwayOnSkillDelete';
import buildNavigateToWorkflowDraftSubscription from './navigateToWorkflowDraft';
import buildRefetchDashboardOnMutationSubscription from './refetchDashboardOnMutation';
import buildRefetchSkillOnMutationSubscription from './refetchSkillOnMutation';
import buildRefetchSkillsOnDeleteSubscription from './refetchSkillsOnDelete';
import buildRefetchCanvasOnConnectionCreateSubscription from './refetchCanvasOnConnectionCreate';
import buildRefetchCanvasOnConnectionUpdateSubscription from './refetchCanvasOnConnectionUpdate';
import buildRefetchCanvasOnConnectionRemoveSubscription from './refetchCanvasOnConnectionRemove';
import buildRefetchCanvasOnItemDescriptionUpdateSubscription from './refetchCanvasOnItemDescriptionUpdate';
import buildRefetchCanvasOnItemActionSubscription from './refetchCanvasOnItemAction';
import buildRefetchCanvasOnItemGenerateSubscription from './refetchCanvasOnItemGenerate';
import buildRefetchCanvasOnItemCreateSubscription from './refetchCanvasOnItemCreate';
import buildRefetchCanvasOnItemsLayoutUpdateSubscription from './refetchCanvasOnItemsLayoutUpdate';
import buildRefetchCanvasOnVisualIdentityUpdateSubscription from './refetchCanvasOnVisualIdentityUpdate';
import buildRefetchAdminPlaybooksOnMutationSubscription from './refetchAdminPlaybooksOnMutation';
import buildRefetchPlaybookBuilderOnMutationSubscription from './refetchPlaybookBuilderOnMutation';
import type { ChatEffectSubscription, GetChatEffectSubscriptionsParams } from '../types';

const getChatEffectSubscriptions = (
    _params: GetChatEffectSubscriptionsParams
): ChatEffectSubscription[] => {
    return [
        buildNavigateToWorkflowDraftSubscription({}),
        buildNavigateToCreatedDashboardSubscription({}),
        buildRefetchDashboardOnMutationSubscription({}),
        buildRefetchSkillOnMutationSubscription({}),
        buildNavigateToCreatedSkillSubscription({}),
        buildNavigateAwayOnSkillDeleteSubscription({}),
        buildRefetchSkillsOnDeleteSubscription({}),
        buildRefetchCanvasOnConnectionCreateSubscription({}),
        buildRefetchCanvasOnConnectionUpdateSubscription({}),
        buildRefetchCanvasOnConnectionRemoveSubscription({}),
        buildRefetchCanvasOnItemDescriptionUpdateSubscription({}),
        buildRefetchCanvasOnItemActionSubscription({}),
        buildRefetchCanvasOnItemGenerateSubscription({}),
        buildRefetchCanvasOnItemCreateSubscription({}),
        buildRefetchCanvasOnItemsLayoutUpdateSubscription({}),
        buildRefetchCanvasOnVisualIdentityUpdateSubscription({}),
        buildRefetchAdminPlaybooksOnMutationSubscription({}),
        buildRefetchPlaybookBuilderOnMutationSubscription({
            id: 'refetch-playbook-builder-on-lifecycle-mutation',
            routePattern: '/admin/playbooks/:playbookId/builder',
        }),
        buildRefetchPlaybookBuilderOnMutationSubscription({
            id: 'refetch-versioned-playbook-builder-on-lifecycle-mutation',
            routePattern: '/admin/playbooks/:playbookId/versions/:versionId/builder',
        }),
        buildRefetchPlaybookBuilderOnMutationSubscription({
            id: 'refetch-playbook-document-on-lifecycle-mutation',
            routePattern: '/admin/playbooks/:playbookId/versions/:versionId/document',
        }),
        buildRefetchPlaybookBuilderOnMutationSubscription({
            id: 'refetch-playbook-slides-on-lifecycle-mutation',
            routePattern: '/admin/playbooks/:playbookId/versions/:versionId/slides',
        }),
        buildRefetchPlaybookBuilderOnMutationSubscription({
            id: 'refetch-playbook-step-settings-on-lifecycle-mutation',
            routePattern: '/admin/playbooks/:playbookId/versions/:versionId/builder/steps/:stepId',
        }),
    ];
};

export default getChatEffectSubscriptions;
